import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1e8d3d60")

_pushScopeId("data-v-1e8d3d60")
const _hoisted_1 = { class: "item-content" }
const _hoisted_2 = { class: "item-content_header" }
const _hoisted_3 = { class: "title ellipsis-2" }
const _hoisted_4 = { class: "item-content_bottom" }
const _hoisted_5 = { class: "item-content_bottom-left1 ellipsis-1" }
const _hoisted_6 = { class: "item-content_bottom-left2" }
const _hoisted_7 = { class: "real-price" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "money" }, "¥", -1)
const _hoisted_9 = {
  key: 0,
  class: "min-price"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_image = _resolveComponent("van-image")

  return (_openBlock(), _createBlock("div", {
    class: "the-item",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toStore(_ctx.item)))
  }, [
    _createVNode(_component_van_image, {
      src: _ctx.item.imageUrl,
      class: "item-image",
      fit: "cover"
    }, null, 8, ["src"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.item.name), 1)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.item.productLabelDetailDTOList, (el, index) => {
            return (_openBlock(), _createBlock("span", {
              class: index == 0 ? 'sex' : index % 2 == 0 ? 'sex' : 'price'
            }, _toDisplayString(el.labelName), 3))
          }), 256))
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.item.sellingPrice), 1)
          ]),
          (_ctx.item.originalPrice)
            ? (_openBlock(), _createBlock("span", _hoisted_9, "原价： ¥" + _toDisplayString(_ctx.item.originalPrice), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})